import { useMapStoreContext } from 'app/src/editor/MapStoreContext';
import { useUndoRedoContext } from 'app/src/editor/UndoRedoContext';
import { InstructionType } from 'app/src/engine/Instruction';
import InstructionCountContainer, { NumberStyle } from 'app/src/game/InstructionCountContainer';
import InstructionNode from 'app/src/game/InstructionNode';
import * as React from 'react';

type Props = {
	instructionType: InstructionType;
};

export default function EditInstructionsPanelInstruction({
	instructionType,
}: Props): React.ReactElement {
	const { mapStore } = useMapStoreContext();
	const { addUndoState } = useUndoRedoContext();

	const { instructionCounts } = mapStore;

	const count = instructionCounts.get(instructionType) || 0;

	return (
		<div key={`instruction-${instructionType}`} className="EditInstructionsPanelInstruction">
			<div className="EditInstructionsPanelInstruction-instructionContainer">
				<InstructionNode key={`instructionType-${instructionType}`} type={instructionType} />
				<div className="EditInstructionsPanelInstruction-buttonContainer">
					<button
						className="EditInstructionsPanelInstruction-button"
						onClick={(): void => {
							mapStore.setInstructionCount(instructionType, count + 1);
							addUndoState();
						}}
					>
						<div className="EditInstructionsPanelInstruction-buttonBody EditInstructionsPanelInstruction-buttonBody--up" />
					</button>
					<button
						className="EditInstructionsPanelInstruction-button"
						onClick={(): void => {
							mapStore.setInstructionCount(instructionType, count > 0 ? count - 1 : 0);
							addUndoState();
						}}
					>
						<div className="EditInstructionsPanelInstruction-buttonBody EditInstructionsPanelInstruction-buttonBody--down" />
					</button>
				</div>
			</div>
			<InstructionCountContainer count={count} numberStyle={NumberStyle.Editor} />
		</div>
	);
}
